module.exports = __webpack_public_path__ + "static/top_service_bg-d4430c013033908bd3bdd7476fbf2f95.png";